import axios from 'axios';
import { store } from '../../index'; // Adjust the path based on your file structure

const getSubdomain = () => {
    const hostname = window.location.hostname;
    if (!hostname) return null;
    const parts = hostname.split('.');
    if (parts.length >= 3 && parts[0] !== 'www') return parts[0];
    return null;
};

const axiosInstance = axios.create({
    //baseURL: 'https://api.test.raborisk.ai ',
});

axiosInstance.interceptors.request.use(
    function (config) {
        const state = store.getState();
        const token = state.auth.token;
        if (token) {

            config.headers['Authorization'] = token;
        }
        const subdomain = getSubdomain();
        if (subdomain) {
            config.headers['x-tenant-subdomain'] = subdomain;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);



axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const status = error.response?.status;
        if (status === 451) {
            if (window.location.hostname !== "test.raborisk.ai" && window.location.hostname !== "www.test.raborisk.ai") {
                const url = error.response.data?.redirect || "https://www.finandfind.com/";
                window.location.replace(url);
                // Fall through to reject so callers can dispatch FETCH_FAILED and
                // clear loading states before the navigation completes.
            }
        }
        if (status === 401 || status === 403) {
            store.dispatch({ type: "LOGGEDOUT" });
        }
        return Promise.reject(error);
    }
);


export default axiosInstance;
